"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.__testonly__ = exports.setLessonExtrasEnabled = exports.setScriptCompleted = exports.setCurrentLessonId = exports.setStudentDefaultsSummaryView = exports.setIsMiniView = exports.setIsSummaryView = exports.setIsAge13Required = exports.disablePostMilestone = exports.updateFocusArea = exports.mergePeerReviewProgress = exports.overwriteResults = exports.mergeResults = exports.useDbProgress = exports.clearResults = exports.setScriptProgress = exports.setCurrentLevelId = exports.initProgress = exports.processedLessons = exports.sendSuccessReport = exports.navigateToNextLevel = exports.navigateToLevelId = exports.queryUserProgress = void 0;
var jquery_1 = __importDefault(require("jquery"));
var lodash_1 = __importDefault(require("lodash"));
var progressTypes_1 = require("@cdo/apps/types/progressTypes");
var toolkit_1 = require("@reduxjs/toolkit");
var progressHelpers_1 = require("@cdo/apps/templates/progress/progressHelpers");
var activityUtils_1 = require("./activityUtils");
var viewAsRedux_1 = require("./viewAsRedux");
var verifiedInstructorRedux_1 = require("@cdo/apps/code-studio/verifiedInstructorRedux");
var lessonLockRedux_1 = require("./lessonLockRedux");
var browserNavigation_1 = require("./browserNavigation");
var constants_1 = require("@cdo/apps/constants");
var progressReduxSelectors_1 = require("./progressReduxSelectors");
var initialState = {
    currentLevelId: null,
    // These first fields never change after initialization.
    currentLessonId: undefined,
    deeperLearningCourse: null,
    // used on multi-page assessments
    saveAnswersBeforeNavigation: null,
    lessons: null,
    lessonGroups: null,
    scriptId: null,
    scriptName: null,
    scriptDisplayName: undefined,
    unitTitle: null,
    courseId: null,
    isLessonExtras: false,
    // The remaining fields do change after initialization.
    // unitProgress is of type unitProgressType (a map of levelId ->
    // studentLevelProgressType)
    unitProgress: {},
    unitProgressHasLoaded: false,
    // note: eventually, we expect usage of this field to be replaced with unitProgress
    levelResults: {},
    focusAreaLessonIds: [],
    peerReviewLessonInfo: null,
    peerReviewsPerformed: [],
    postMilestoneDisabled: false,
    isAge13Required: false,
    // Do students see summary view by default?
    studentDefaultsSummaryView: true,
    isSummaryView: true,
    isMiniView: false,
    hasFullProgress: false,
    lessonExtrasEnabled: false,
    // Note: usingDbProgress === "user is logged in". However, it is
    // possible that we can get the user progress back from the DB
    // prior to having information about the user login state.
    // TODO: Use sign in state to determine where to source user progress from
    usingDbProgress: false,
    currentPageNumber: progressTypes_1.PUZZLE_PAGE_NONE,
    courseVersionId: undefined,
    unitDescription: undefined,
    unitStudentDescription: undefined,
    changeFocusAreaPath: undefined,
    unitCompleted: undefined,
};
var progressSlice = (0, toolkit_1.createSlice)({
    name: 'progress',
    initialState: initialState,
    reducers: {
        initProgress: function (state, action) {
            var lessons = action.payload.lessons;
            // Re-initializing with full set of lessons shouldn't blow away currentLessonId
            var currentLessonId = state.currentLessonId ||
                (lessons.length === 1 ? lessons[0].id : undefined);
            state.currentLevelId || (state.currentLevelId = action.payload.currentLevelId);
            state.deeperLearningCourse = action.payload.deeperLearningCourse;
            state.saveAnswersBeforeNavigation =
                action.payload.saveAnswersBeforeNavigation;
            state.lessons = processedLessons(lessons, action.payload.deeperLearningCourse);
            state.lessonGroups = action.payload.lessonGroups;
            state.peerReviewLessonInfo = action.payload.peerReviewLessonInfo;
            state.scriptId = action.payload.scriptId;
            state.scriptName = action.payload.scriptName;
            state.scriptDisplayName = action.payload.scriptDisplayName;
            state.unitTitle = action.payload.unitTitle;
            state.unitDescription = action.payload.unitDescription;
            state.unitStudentDescription = action.payload.unitStudentDescription;
            state.courseId = action.payload.courseId;
            state.courseVersionId = action.payload.courseVersionId;
            state.currentLessonId = currentLessonId;
            state.hasFullProgress = action.payload.isFullProgress;
            state.isLessonExtras = action.payload.isLessonExtras;
            state.currentPageNumber = action.payload.currentPageNumber;
        },
        setCurrentLevelId: function (state, action) {
            state.currentLevelId = action.payload;
        },
        setScriptProgress: function (state, action) {
            state.unitProgress = (0, progressHelpers_1.processServerStudentProgress)(action.payload);
            state.unitProgressHasLoaded = true;
        },
        clearResults: function (state) {
            state.levelResults = initialState.levelResults;
        },
        useDbProgress: function (state) {
            state.usingDbProgress = true;
        },
        mergeResults: function (state, action) {
            var newLevelResults = {};
            var combinedLevels = Object.keys(__assign(__assign({}, state.levelResults), action.payload));
            combinedLevels.forEach(function (key) {
                var levelId = parseInt(key);
                newLevelResults[levelId] = (0, activityUtils_1.mergeActivityResult)(state.levelResults[levelId], action.payload[levelId]);
            });
            state.levelResults = newLevelResults;
        },
        overwriteResults: function (state, action) {
            state.levelResults = action.payload;
        },
        mergePeerReviewProgress: function (state, action) {
            if (state.peerReviewLessonInfo) {
                state.peerReviewLessonInfo = __assign(__assign({}, state.peerReviewLessonInfo), { levels: state.peerReviewLessonInfo.levels.map(function (level, index) { return (__assign(__assign({}, level), action.payload[index])); }) });
            }
        },
        updateFocusArea: {
            reducer: function (state, action) {
                state.changeFocusAreaPath = action.payload.changeFocusAreaPath;
                state.focusAreaLessonIds = action.payload.focusAreaLessonIds;
            },
            prepare: function (changeFocusAreaPath, focusAreaLessonIds) {
                return {
                    payload: {
                        changeFocusAreaPath: changeFocusAreaPath,
                        focusAreaLessonIds: focusAreaLessonIds,
                    },
                };
            },
        },
        disablePostMilestone: function (state) {
            state.postMilestoneDisabled = true;
        },
        setIsAge13Required: function (state, action) {
            state.isAge13Required = action.payload;
        },
        setIsSummaryView: function (state, action) {
            state.isSummaryView = action.payload;
        },
        setIsMiniView: function (state, action) {
            state.isMiniView = action.payload;
        },
        setStudentDefaultsSummaryView: function (state, action) {
            state.studentDefaultsSummaryView = action.payload;
        },
        setCurrentLessonId: function (state, action) {
            // if we already have a currentLessonId, that means we're on a puzzle page,
            // and we want currentLessonId to remain the same (rather than reflecting
            // the last lesson the user has made progress on).
            if (!state.currentLessonId) {
                state.currentLessonId = action.payload;
            }
        },
        setScriptCompleted: function (state) {
            state.unitCompleted = true;
        },
        setLessonExtrasEnabled: function (state, action) {
            state.lessonExtrasEnabled = action.payload;
        },
    },
    extraReducers: (_a = {},
        // TODO: When we convert viewAsRedux to redux-toolkit, we will need to use
        // createAction there instead of referencing the string here.
        _a[viewAsRedux_1.SET_VIEW_TYPE] = function (state, action) {
            state.isSummaryView =
                action.viewType === progressTypes_1.ViewType.Participant &&
                    state.studentDefaultsSummaryView;
        },
        _a),
});
var queryUserProgress = function (userId) {
    return function (dispatch, getState) {
        var state = getState().progress;
        return userProgressFromServer(state, dispatch, userId);
    };
};
exports.queryUserProgress = queryUserProgress;
// The user has navigated to a new level in the current lesson,
// so we should update the browser and also set this as the new
// current level.
function navigateToLevelId(levelId) {
    return function (dispatch, getState) {
        var state = getState().progress;
        if (!state.currentLessonId) {
            return;
        }
        var newLevel = getLevelById(state.lessons, state.currentLessonId, levelId);
        if (!newLevel) {
            return;
        }
        (0, browserNavigation_1.updateBrowserForLevelNavigation)(state, newLevel.url, levelId);
        dispatch((0, exports.setCurrentLevelId)(levelId));
    };
}
exports.navigateToLevelId = navigateToLevelId;
// Navigate to the next level in the progression, if it exists.
function navigateToNextLevel() {
    return function (dispatch, getState) {
        var levelId = (0, progressReduxSelectors_1.nextLevelId)(getState());
        if (levelId === undefined) {
            return;
        }
        dispatch(navigateToLevelId(levelId));
    };
}
exports.navigateToNextLevel = navigateToNextLevel;
// The user has successfully completed the level and the page
// will not be reloading.
function sendSuccessReport(appType) {
    return function (dispatch, getState) {
        var state = getState().progress;
        var levelId = state.currentLevelId;
        if (!state.currentLessonId || !levelId) {
            return;
        }
        var currentLevel = getLevelById(state.lessons, state.currentLessonId, levelId);
        if (!currentLevel) {
            return;
        }
        var scriptLevelId = currentLevel.id;
        // The server does not appear to use the user ID parameter,
        // so just pass 0, like some other milestone posts do.
        var userId = 0;
        // An ideal score.
        var idealPassResult = constants_1.TestResults.ALL_PASS;
        var data = {
            app: appType,
            result: true,
            testResult: idealPassResult,
        };
        fetch("/milestone/".concat(userId, "/").concat(scriptLevelId, "/").concat(levelId), {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify(data),
        }).then(function (response) {
            var _a;
            if (response.ok && levelId !== null) {
                // Update the progress store by merging in this
                // particular result immediately.
                dispatch((0, exports.mergeResults)((_a = {}, _a[levelId] = idealPassResult, _a)));
            }
        });
    };
}
exports.sendSuccessReport = sendSuccessReport;
// Helpers
/**
 * Requests user progress from the server and dispatches other redux actions
 * based on the server's response data.
 */
var userProgressFromServer = function (state, dispatch, userId) {
    if (userId === void 0) { userId = null; }
    if (!state.scriptName) {
        var message = "Could not request progress for user ID ".concat(userId, " from server: scriptName must be present in progress redux.");
        throw new Error(message);
    }
    // If we have a userId, we can clear any progress in redux and request all progress
    // from the server.
    if (userId) {
        dispatch((0, exports.clearResults)());
    }
    return jquery_1.default.ajax({
        url: "/api/user_progress/".concat(state.scriptName),
        method: 'GET',
        data: { user_id: userId },
    }).done(function (data) {
        if (!data || lodash_1.default.isEmpty(data)) {
            return;
        }
        if (data.isVerifiedInstructor) {
            dispatch((0, verifiedInstructorRedux_1.setVerified)());
        }
        // We are on an overview page if currentLevelId is undefined.
        var onOverviewPage = !state.currentLevelId;
        // Show lesson plan links and other teacher info if instructor and on unit overview page.
        if ((data.isInstructor || data.teacherViewingStudent) &&
            !data.deeperLearningCourse &&
            onOverviewPage) {
            // Default to summary view if teacher is viewing their student, otherwise default to detail view.
            dispatch((0, exports.setIsSummaryView)(data.teacherViewingStudent));
        }
        if (data.focusAreaLessonIds) {
            dispatch((0, exports.updateFocusArea)(data.changeFocusAreaPath, data.focusAreaLessonIds));
        }
        dispatch((0, lessonLockRedux_1.authorizeLockable)(data.lockableAuthorized));
        if (data.completed) {
            dispatch((0, exports.setScriptCompleted)());
        }
        // Merge progress from server
        if (data.progress) {
            dispatch((0, exports.setScriptProgress)(data.progress));
            // Note that we set the full progress object above in redux but also set
            // a map containing just level results. This is the legacy code path and
            // the goal is to eventually update all code paths to use unitProgress
            // instead of levelResults.
            var levelResults = lodash_1.default.mapValues(data.progress, progressHelpers_1.getLevelResult);
            dispatch((0, exports.mergeResults)(levelResults));
            if (data.peerReviewsPerformed) {
                dispatch((0, exports.mergePeerReviewProgress)(data.peerReviewsPerformed));
            }
            if (data.current_lesson) {
                dispatch((0, exports.setCurrentLessonId)(data.current_lesson));
            }
        }
    });
};
/**
 * Given an array of lessons, a lesson ID, and a level ID, returns
 * the requested level.
 */
function getLevelById(lessons, lessonId, levelId) {
    var lesson = lessons === null || lessons === void 0 ? void 0 : lessons.find(function (lesson) { return lesson.id === lessonId; });
    if (lesson) {
        return lesson.levels.find(function (level) { return level.ids.find(function (id) { return id === levelId; }); });
    }
}
/**
 * Does some processing of our passed in lesson, namely
 * - Removes 'hidden' field
 * - Adds 'lessonNumber' field for non-PLC lessons which
 * are not lockable or have a lesson plan
 */
function processedLessons(lessons, isPlc) {
    var numLessonsWithLessonPlan = 0;
    return lessons.map(function (lesson) {
        var lessonNumber;
        if (!isPlc && lesson.numberedLesson) {
            numLessonsWithLessonPlan++;
            lessonNumber = numLessonsWithLessonPlan;
        }
        return __assign(__assign({}, lodash_1.default.omit(lesson, 'hidden')), { lessonNumber: lessonNumber });
    });
}
exports.processedLessons = processedLessons;
exports.initProgress = (_b = progressSlice.actions, _b.initProgress), exports.setCurrentLevelId = _b.setCurrentLevelId, exports.setScriptProgress = _b.setScriptProgress, exports.clearResults = _b.clearResults, exports.useDbProgress = _b.useDbProgress, exports.mergeResults = _b.mergeResults, exports.overwriteResults = _b.overwriteResults, exports.mergePeerReviewProgress = _b.mergePeerReviewProgress, exports.updateFocusArea = _b.updateFocusArea, exports.disablePostMilestone = _b.disablePostMilestone, exports.setIsAge13Required = _b.setIsAge13Required, exports.setIsSummaryView = _b.setIsSummaryView, exports.setIsMiniView = _b.setIsMiniView, exports.setStudentDefaultsSummaryView = _b.setStudentDefaultsSummaryView, exports.setCurrentLessonId = _b.setCurrentLessonId, exports.setScriptCompleted = _b.setScriptCompleted, exports.setLessonExtrasEnabled = _b.setLessonExtrasEnabled;
exports.default = progressSlice.reducer;
// export private function(s) to expose to unit testing
exports.__testonly__ = IN_UNIT_TEST
    ? {
        userProgressFromServer: userProgressFromServer,
    }
    : {};
